import { dialog } from "../../../../nq-component";
import BaseListPresenter from "../../../../base/BaseListPresenter";

import {
  deleteObjectUseCase,
  updateObjectUseCase,
} from "../../../../usecases/object";
import { getCurrentUserUseCase } from "../../../../usecases/user";
import { liveQueryUseCase } from "../../../../usecases/livequery";

class OnlineApplicantListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  componentDidMount() {
    this.init();
    // this.subscribe();
    this.startPolling();
    return this.getObjects();
  }

  // subscribe() {
  //   const query = {
  //     collection: "online_applicants",
  //     where: {},
  //   };

  //   const insertSubscription = liveQueryUseCase().execute(query, "afterInsert");
  //   insertSubscription.on("create", (newObject) => {
  //     this.objects?.push(newObject);
  //     console.log("real one", this.objects);

  //     this.view.setObjects(this.objects);
  //   });

  //   const updateSubscription = liveQueryUseCase().execute(query, "afterUpdate");
  //   updateSubscription.on("update", (updatedProduct) => {
  //     const index = this.objects?.findIndex(
  //       (obj) => obj.id === updatedProduct.id
  //     );
  //     if (index !== -1) {
  //       this.objects[index] = updatedProduct;

  //       this.view.setObjects(this.objects);
  //     }
  //   });

  //   const deleteSubscription = liveQueryUseCase().execute(query, "afterDelete");
  //   deleteSubscription.on("delete", (deletedProduct) => {
  //     this.objects = this.objects.filter((obj) => obj.id !== deletedProduct.id);
  //     this.view.setObjects(this.objects);
  //   });

  //   [insertSubscription, updateSubscription, deleteSubscription].forEach(
  //     (subscription) => {
  //       subscription.on("error", (error) => {
  //         console.error("Subscription error:", error);
  //       });
  //     }
  //   );
  // }

  startPolling() {
    this.pollingInterval = setInterval(() => {
      this.pollObjects();
    }, 3000);
  }

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  async pollObjects() {
    if (this.progress || this.isPolling) return;
    if (!this.objects || this.objects.length === 0) return;

    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    query.skip = 0;

    this.isPolling = true;
    try {
      const latest = await this.findObjectUseCase.execute(collection, query);
      const existingIds = new Set(this.objects.map((obj) => obj.id));
      const newObjects = (latest || []).filter(
        (obj) => !existingIds.has(obj.id),
      );

      if (newObjects.length === 0) return;

      this.objects = [...newObjects, ...this.objects];
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);

      if (this.audio) {
        this.audio.play().catch((err) => {
          console.warn("Audio play blocked by browser or failed:", err);
        });
      }
    } catch (error) {
      console.error("Polling error:", error);
    } finally {
      this.isPolling = false;
    }
  }

  init() {
    this.limit = 20;
    this.where = { "recruiter.id": { $exists: false } };
    this.search = {};
    this.filter = {};
    this.include = ["employee"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      console.log(this.objects);
      this.view.setObjects(this.objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  onClickAdd() {
    const collection = this.view.getCollectionName();
    this.view.navigateTo("/admin/employee/form");
  }

  async onClickView(empDetails) {
    console.log("emp form", empDetails);
    this.view.navigateTo(`/recruiter/online-applicant/form/${empDetails?.id}`);
  }

  onChangePosition(value, schema) {
    this.reset();
    this.filter = {
      positionApplied: { $regex: value, $options: "i" },
    };
    this.getObjects();
  }

  onChangeReference(value, schema) {
    this.reset();
    this.filter = {
      referenceNumber: { $regex: value, $options: "i" },
    };
    this.getObjects();
  }

  //   onChangePosition(value, schema) {
  //     this.reset();

  //     const excludedFields = [
  //       "id",
  //       "created",
  //       "updated",
  //       "acl",
  //       "status",
  //       "applicant",
  //       "recruiter",
  //       "coordinator",
  //     ];

  //     this.filter = {
  //       $or: Object.keys(schema.fields)
  //         .filter(
  //           (field) =>
  //             !excludedFields.includes(field) &&
  //             schema.fields[field].type === "String"
  //         )
  //         .map((field) => ({
  //           [field]: { $regex: value, $options: "i" },
  //         })),
  //     };

  //     this.getObjects();
  //   }
}

export default OnlineApplicantListPresenter;
